/** Students / learners. Owner and Course Admin are not idle-watched. */
export const IDLE_WARNING_AFTER_MS = 30 * 60 * 1000;
export const IDLE_LOGOUT_GRACE_MS = 30 * 1000;

const SKIP_IDLE = [
  '/login',
  '/register',
  '/forgot-password',
  '/auth/linkedin/callback',
  '/auth/google/callback',
];

export function shouldWatchIdle(pathname: string): boolean {
  return !SKIP_IDLE.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}
